import { DomHelper } from "./domHelper";
import { DEBUG } from "./config";
import { getAppCardNode } from "./appCardDefault";
import { getBackendData, sendBackendData } from "./xhrbackend";
export function appTOTP(username, bearerToken, parentNode, app, userResponse) {
    if (DEBUG)
        console.log("-->appTOTPRender");
    const idString = 'rudi-app-totp';
    const cardNode = getAppCardNode(parentNode, app, userResponse.username, userResponse.odDeskPreferences, bearerToken, false, [], null, (event) => {
        if (DEBUG)
            console.log("TOTP handle Click");
        let injectNode = cardNode.querySelector(`.rudi-app-inject`);
        handleClickOpen(injectNode, event, username, bearerToken, userResponse.odDeskPreferences, idString);
    });
}
function handleClickOpen(injectNode, event, username, bearerToken, userPreferences, idString) {
    let appNode;
    if (!injectNode) {
        injectNode = document.getElementById(idString);
    }
    else {
        injectNode.classList.remove('rudi-app-inject');
        injectNode.classList.remove('disabled');
        injectNode.classList.add('rudi-app-interaction');
        injectNode.setAttribute("id", idString);
    }
    try {
        appNode = DomHelper.getFirstParentWithClass(injectNode, 'rudi-app');
    }
    catch (e) {
        appNode = event.target;
    }
    if (appNode) {
        if (appNode.classList.contains("app-open")) {
        }
        else {
            appNode.classList.add('app-open');
            appNode.classList.remove('rudi-max-height');
            DomHelper.appendSpinner(injectNode);
            getBackendData("", `/users/${username}/totp/setup`, "GET", "application/json", bearerToken, (response) => {
                DomHelper.removeSpinner(injectNode);
                const data = JSON.parse(response.target.response);
                renderTOTPSetup(injectNode, username, bearerToken, data, idString, appNode);
                DomHelper.appendCloseSection(appNode, () => {
                    closeApp(idString, appNode);
                });
            });
        }
    }
}
function renderTOTPSetup(parentNode, username, bearerToken, data, idString, appNode) {
    parentNode.innerHTML = "";
    const container = DomHelper.appendNode(parentNode, "div", ["totp-setup-container", "text-center", "p-3"], []);
    if (data.configured) {
        DomHelper.appendNode(container, "p", [], [], "Es ist bereits ein TOTP aktiviert.");
        const deleteBtn = DomHelper.appendNode(container, "button", ["btn", "btn-primary", "mt-3", "w-100"], [], "Löschen");
        deleteBtn.addEventListener("click", () => {
            DomHelper.appendSpinner(container);
            sendBackendData('', `/users/${username}/totp`, "DELETE", "application/json", bearerToken, {}, (response) => {
                DomHelper.removeSpinner(container);
                const result = JSON.parse(response.target.response);
                if (result.valid) {
                    container.innerHTML = `
                    <div class="alert alert-success">
                        <i class="fa-solid fa-check-circle fa-2x mb-2"></i>
                        <p>TOTP wurde erfolgreich aktiviert!</p>
                    </div>
                `;
                    setTimeout(() => {
                        closeApp(idString, appNode);
                    }, 3000);
                }
                else {
                    DomHelper.alertMessage("Ungültiger Code. Bitte versuchen Sie es erneut.");
                }
            });
        });
    }
    else {
        DomHelper.appendNode(container, "p", [], [], "Scannen Sie diesen QR-Code mit Ihrer Authenticator-App (z.B. Google Authenticator, Authy, FreeOTP).");
        const qrImg = DomHelper.appendNode(container, "img", ["img-fluid", "mb-3"], [{
                attr: "src",
                value: data.qrCode
            }]);
        qrImg.style.maxWidth = "200px";
        const secretInfo = DomHelper.appendNode(container, "div", ["mb-3"], []);
        DomHelper.appendNode(secretInfo, "small", ["text-muted"], [], "Secret: " + data.secret);
        const formGroup = DomHelper.appendNode(container, "div", ["form-group", "mt-3"], []);
        DomHelper.appendNode(formGroup, "label", ["form-label"], [], "Verifizierungs-Code");
        const tokenInput = DomHelper.appendNode(formGroup, "input", ["form-control", "text-center"], [
            { attr: "type", value: "text" },
            { attr: "maxlength", value: "6" }
        ]);
        tokenInput.style.fontSize = "1.5rem";
        tokenInput.style.letterSpacing = "0.5rem";
        const verifyBtn = DomHelper.appendNode(container, "button", ["btn", "btn-primary", "mt-3", "w-100"], [], "Verifizieren & Aktivieren");
        verifyBtn.addEventListener("click", () => {
            const token = tokenInput.value;
            if (token.length !== 6) {
                DomHelper.alertMessage("Bitte geben Sie einen 6-stelligen Code ein.");
                return;
            }
            const oldInnerHTML = container.innerHTML;
            DomHelper.appendSpinner(container);
            sendBackendData('', `/users/${username}/totp/verify`, "POST", "application/json", bearerToken, { token: token }, (response) => {
                DomHelper.removeSpinner(container);
                const result = JSON.parse(response.target.response);
                if (result.valid) {
                    container.innerHTML = `
                    <div class="alert alert-success">
                        <i class="fa-solid fa-check-circle fa-2x mb-2"></i>
                        <p>TOTP wurde erfolgreich aktiviert!</p>
                    </div>
                `;
                    setTimeout(() => {
                        closeApp(idString, appNode);
                    }, 3000);
                }
                else {
                    DomHelper.removeSpinner(container);
                    container.innerHTML = oldInnerHTML;
                    DomHelper.showMessage({
                        appcn: "",
                        appdn: "",
                        duration: 5000,
                        header: "Error",
                        icon: "fa-circle-exclamation",
                        message: 'Ungültiger Code. Bitte versuchen Sie es erneut.',
                        type: 'error',
                        version: ""
                    }, null, bearerToken);
                }
            });
        });
    }
}
function closeApp(idString, appNode) {
    const parentNode = document.getElementById(idString);
    if (parentNode) {
        parentNode.innerHTML = "";
    }
    appNode.classList.remove('app-open');
    appNode.classList.add('rudi-max-height');
}
